import logo from 'assets/header-prevencor-xx.png';
import md5 from 'md5';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import QRCode from 'qrcode';
import fetchImageBase64, { getTiposAtestado } from 'utils/helpers';
import { pdfMakeGetBlob } from 'utils/pdfBlob';
import { buildValidacaoQrCodeUrl } from 'utils/validacaoQrCode';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function buildBlocoAssinaturaDigital({
  atestado,
  nomeMed,
  crmMed,
  codAtestado,
  codPac,
  qrCodeAtestado,
}) {
  return {
    columns: [
      {
        width: 65,
        image: qrCodeAtestado,
        fit: [58, 58],
        alignment: 'center',
      },
      {
        width: '*',
        margin: [6, 2, 0, 0],
        stack: [
          {
            text: `Documento assinado eletronicamente — Médico: Dr. ${nomeMed} - CRM: ${crmMed}`,
            bold: true,
            fontSize: 9,
            margin: [0, 0, 0, 2],
          },
          {
            text: `Autenticação: ${md5(JSON.stringify(atestado || {}))}`,
            italics: true,
            fontSize: 8,
            margin: [0, 0, 0, 2],
          },
          {
            text: `VALIDADOR DE ATESTADO DIGITAL - PREVENCOR | CÓD. ATESTADO: ${codAtestado} - CÓD. PACIENTE: ${codPac}`,
            bold: true,
            fontSize: 8,
            margin: [0, 0, 0, 2],
          },
          {
            text: 'Aponte a câmera do celular para o QRCode e verifique a validade deste documento.',
            italics: true,
            fontSize: 7.5,
          },
        ],
      },
    ],
    margin: [0, 0, 0, 6],
  };
}

function buildLinhaCreditosPaginacao(currentPage, pageCount) {
  return {
    text: `Prevencor Marília — Página ${currentPage} de ${pageCount}`,
    alignment: 'center',
    fontSize: 7.5,
  };
}

export async function generateAtestadoPdf({ atestado, prontuario }) {
  const tiposAtestado = getTiposAtestado();
  const tipoNomeRaw =
    tiposAtestado.find((t) => t.id === atestado?.TIPOATESTADO || t.tipo === atestado?.TIPOATESTADO)
      ?.tipo || 'Atestado';
  const tipoNome = tipoNomeRaw.toUpperCase() === 'TEXTO LIVRE' ? '' : tipoNomeRaw;

  const logoBase64 = await fetchImageBase64(logo);
  const codAtestado = atestado?.CODATESTADO || `NEW-${Date.now()}`;
  const codPac = atestado?.CODPAC || prontuario?.CODPAC || '';
  const nomeMed = atestado?.NOMEMED || '';
  const crmMed = atestado?.CRMMED || '';
  const descricao = atestado?.DESCRICAO || '';

  const qrCodeAtestado = await QRCode.toDataURL(
    buildValidacaoQrCodeUrl({
      tipo: 'atestado',
      codDocumento: codAtestado,
      codPaciente: codPac,
    })
  );

  const header = () => ({
    image: logoBase64,
    width: 550,
    alignment: 'center',
    margin: [0, 10, 0, 10],
  });

  const footer = (currentPage, pageCount) => ({
    margin: [30, 8, 30, 0],
    fontSize: 8,
    stack: [
      buildBlocoAssinaturaDigital({
        atestado,
        nomeMed,
        crmMed,
        codAtestado,
        codPac,
        qrCodeAtestado,
      }),
      buildLinhaCreditosPaginacao(currentPage, pageCount),
    ],
  });

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [40, 110, 40, 100],
    content: [
      {
        text: tipoNome.toUpperCase(),
        style: 'subheader',
        alignment: 'center',
        margin: [0, 0, 0, tipoNome ? 20 : 0],
      },
      {
        table: {
          widths: ['*'],
          body: [
            [
              {
                stack: [
                  {
                    text: 'IDENTIFICAÇÃO DO MÉDICO',
                    bold: true,
                    margin: [0, 0, 0, 5],
                  },
                  { text: `Médico: Dr(a). ${nomeMed}`, margin: [0, 0, 0, 2] },
                  { text: `CRM: ${crmMed}`, margin: [0, 0, 0, 2] },
                  {
                    text: 'Endereço: RUA CLÁUDIO MANOEL DA COSTA, 56 - BAIRRO MARIA IZABEL - MARÍLIA/SP - CEP 17515-460 - TELEFONE 14 3402-2700',
                    margin: [0, 0, 0, 0],
                  },
                ],
              },
            ],
          ],
        },
        layout: {
          hLineWidth: () => 1,
          vLineWidth: () => 1,
          hLineColor: () => 'black',
          vLineColor: () => 'black',
        },
        margin: [30, 0, 30, 10],
      },
      {
        text: descricao,
        margin: [30, 10, 30, 10],
        fontSize: 11,
        alignment: 'justify',
        lineHeight: 1.5,
      },
    ],
    styles: {
      header: { fontSize: 18, bold: true },
      subheader: { fontSize: 14, bold: true },
      footer: { italics: true },
    },
    header,
    footer,
    defaultStyle: { fontSize: 11 },
  };

  return pdfMakeGetBlob(pdfMake.createPdf(docDefinition));
}
